import { render, staticRenderFns } from "./InboxList.vue?vue&type=template&id=1d5f04a0&scoped=true&"
import script from "./InboxList.vue?vue&type=script&lang=js&"
export * from "./InboxList.vue?vue&type=script&lang=js&"
import style0 from "./InboxList.vue?vue&type=style&index=0&id=1d5f04a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f04a0",
  null
  
)

export default component.exports